module.exports = __webpack_public_path__ + "static/1-a5552bc27e074d8479b3970ac6dd0883.jpg";